@if (loadingOffer()) {
  <app-loading />
}

@if (errorOffer()) {
  <app-error-data [title]="errorOffer()" />
}

@if (!loadingOffer() && !errorOffer()) {
  <div class="mx-auto max-w-6xl space-y-8 p-6" [dir]="isArabic() ? 'rtl' : 'ltr'">
    <div class="flex items-center justify-start gap-12 pb-2">
      <div>
        @if (offerData()) {
          <h1 class="text-3xl font-bold text-gray-900">
            {{ isArabic() ? offerData()?.titleAr : offerData()?.titleEn }}
          </h1>
        }
        @if (bundleData()) {
          <h1 class="text-3xl font-bold text-gray-900">
            {{ isArabic() ? bundleData()?.titleAr : bundleData()?.titleEn }}
          </h1>
        }
      </div>

      @if (offerBundleType() === "offer") {
        <div class="flex items-center gap-3">
          <span
            class="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 px-4 py-1.5 text-sm font-semibold whitespace-nowrap text-amber-700">
            <span class="h-2 w-2 rounded-full bg-amber-400"></span>
            @if (offerData()?.buyQuantity && offerData()?.getQuantity) {
              <span>{{ isArabic() ? "اشترِ" : "Buy" }}</span>
              <span class="font-bold">{{ offerData()?.buyQuantity }}</span>
              <span>{{ isArabic() ? "واحصل على" : "Get" }}</span>
              <span class="font-bold">{{ offerData()?.getQuantity }}</span>
              <span>{{ isArabic() ? "مجاناً" : "Free" }}</span>
            } @else {
              <span>{{ isArabic() ? offerData()?.offerType?.titleAr : offerData()?.offerType?.titleEn }}</span>
            }
          </span>
        </div>
      }
      @if (offerBundleType() === "bundle") {
        <div class="flex items-center gap-8">
          <div>
            <label for="">
              {{ isArabic() ? "إجمالي سعر الصيدلي قبل الخصم" : "Total Pharmacy Price Before Discount" }}
            </label>
            <p class="font-semibold">
              <del>{{ bundleData()?.totalPharmacyPriceBeforeDiscount }}</del>
              <span class="text-xs text-gray-500">{{ isArabic() ? "ج.م" : "EGP" }}</span>
            </p>
          </div>
          <div>
            <label for="">
              {{ isArabic() ? "سعر الباقة بعد الخصم" : "Bundle Price After Discount" }}
            </label>
            <p class="font-semibold text-emerald-600">
              {{ bundleData()?.totalPharmacyPriceAfterDiscount }}
              <span class="text-xs text-gray-500">{{ isArabic() ? "ج.م" : "EGP" }}</span>
            </p>
          </div>
        </div>
      }
      @if (offerBundleType() === "bundle") {
        <div>
          <app-stepper
            (increaseQty)="increaseQty()"
            (decreaseQty)="decreaseQty()"
            (qtyChange)="qtyChange($event)"
            (errorQuantity)="errorQuantity()"
            [itemQuantity]="+itemQuantity()" />

          <p class="text-xs text-red-500">
            {{ errorQty() }}
          </p>
        </div>
        <div>
          <app-submit-button [disabled]="isPharmacySuspended()" (click)="onAddToCart()">
            @if (isAddingToCart()) {
              <span i18n="@@loading" class="block w-[6rem]">loading...</span>
            } @else {
              <span i18n="@@addToCart" class="block w-[6rem]">Add To Cart</span>
            }
          </app-submit-button>
        </div>
        @if (isErrorAddToCart()) {
          <div class="w-[11rem]">
            <app-error [apiError]="isErrorAddToCart()" />
          </div>
        }
      }
    </div>

    <div>
      <p class="mb-3 font-mono text-xs tracking-wider text-gray-400 uppercase">
        @if (offerBundleType() === "offer") {
          {{ isArabic() ? "صور العرض" : "Offer Images" }}
        }
        @if (offerBundleType() === "bundle") {
          {{ isArabic() ? "صور الباقة" : "Bundle Images" }}
        }
      </p>
      <div class="w-full">
        @if (offerBundleType() === "offer") {
          <app-image-carousel
            type="customer-offer"
            [profileImage]="offerImageUrl()"
            [extraImages]="offerImages()"
            [isLoading]="isLoadingImages()" />
        }
        @if (offerBundleType() === "bundle") {
          <app-image-carousel
            type="customer-offer"
            [profileImage]="bundleImageUrl()"
            [extraImages]="bundleImages()"
            [isLoading]="isLoadingImages()" />
        }
      </div>
    </div>

    @if (offerData()?.descriptionAr || offerData()?.descriptionEn) {
      <div class="rounded-xl border border-l-4 border-gray-200 border-l-emerald-500 bg-white p-5 shadow-sm">
        <p class="text-sm leading-relaxed text-gray-700">
          {{ isArabic() ? offerData()?.descriptionAr || "" : offerData()?.descriptionEn || "" }}
        </p>
      </div>
    }
    @if (bundleData()?.descriptionAr || bundleData()?.descriptionEn) {
      <div class="rounded-xl border border-l-4 border-gray-200 border-l-emerald-500 bg-white p-5 shadow-sm">
        <p class="text-sm leading-relaxed text-gray-700">
          {{ isArabic() ? bundleData()?.descriptionAr || "" : bundleData()?.descriptionEn || "" }}
        </p>
      </div>
    }

    @if (offerBundleType() === "bundle") {
      <div>
        <div class="mb-4 flex items-center justify-between">
          <p class="font-mono text-xs tracking-wider text-gray-400 uppercase">
            {{ isArabic() ? "الأصناف المشمولة" : "Included Products" }}
          </p>
          <span class="rounded-full border border-gray-200 bg-gray-100 px-3 py-0.5 font-mono text-xs text-gray-500">
            {{ bundleData()?.products?.length }} {{ isArabic() ? "صنف" : "items" }}
          </span>
        </div>

        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          @for (p of bundleProductsFlat(); track p.product.id) {
            <app-product-card-component [product]="p.product" [variant]="'bundle'" [bundleQuantity]="p.quantity" />
          } @empty {
            <div class="col-span-full flex flex-col items-center justify-center py-16 text-center">
              <app-medicine-icon />
              <p class="text-sm text-gray-400">
                {{ isArabic() ? "لا توجد أصناف " : "No products found" }}
              </p>
            </div>
          }
        </div>
      </div>
    }
    @if (offerBundleType() === "offer" && enrichedOfferForSelector()) {
      <div class="mt-8">
        <app-offer-product-selector
          [offer]="enrichedOfferForSelector()!"
          [mode]="'pharmacist'"
          [pharmacyId]="selectedPharmacy()?.id"
          [disabled]="isPharmacySuspended()"
          (cancel)="onCancelOfferSelection()"
          (confirmOffer)="onConfirmOfferProducts()" />
      </div>
    }
  </div>
}

@if (isSuccessOfferAddToCart()) {
  <app-successful-notification
    type="success"
    i18n-title="@@offer.success.added"
    title="Offer has been added To Cart successfully." />
}

@if (isSuccessBundleAddToCart()) {
  <app-successful-notification
    type="success"
    i18n-title="@@bundle.success.added"
    title="Bundle has been added To Cart successfully." />
}
